// extracted by mini-css-extract-plugin
export default {"wrapper":"use-cases_wrapper__Ablwi","content-left":"use-cases_content-left__WR2WD","content-right":"use-cases_content-right__1-0Dg"};